import { action } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { FeedbackCategory } from '../components/InlineFeedbackDialog';

export interface InlineFeedbackDialogResponseProps {
    sessionId: string;
    inlineFeedbackResponseText: string;
    inlineFeedbackResponseCategories: string[];
    isContentDonated: boolean;
    isUVTicketCreated: boolean;
    odsResponse: string;
    subCategories?: ObservableMap<string, FeedbackCategory[]>;
}

export const logInlineFeedbackDialogResponse = action(
    'logInlineFeedbackDialogResponse',
    (inlineFeedbackDialogResponse: InlineFeedbackDialogResponseProps) =>
        inlineFeedbackDialogResponse
);
